import React, { useState, Dispatch, SetStateAction, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "../../context";
import { _Team, _Category, _Space, _Active, _Type } from "../../components/CategoriesPicker/types";
import api from "../../api";
import { message } from "antd";
import CreateMenu from "../../components/CreateMenu";
import { isFocusEnv } from "@/utils";
import { notUseJoySpaceOffline, openLowCode } from "@/components/Joyspace/util";
import Bus from "@/utils/bus";
import { getNetCheckUrl } from "@/config/config";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import NetworkCheck, { useNavigator } from "@/utils/NetworkCheck";
import { PageRouteName } from "../../batchOperate";

interface IProps {
  disabledCreateFolder?: boolean;
  folderId: string;
  gid: string;
}

export default function (props: IProps) {
  const { disabledCreateFolder = false, folderId, gid } = props;
  const lang = useTranslation();
  const [currentNetOffline, setCurrentNetOffline] = useState(!useNavigator.onLine);

  const { canCreatePage, canCreateFolder } = useMemo(() => {
    console.log(folderId, "activeIdactiveId===>");
    if ((!notUseJoySpaceOffline() && currentNetOffline) || (gid && currentNetOffline)) {
      return { canCreatePage: false, canCreateFolder: false };
    } else {
      return { canCreatePage: true, canCreateFolder: true };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNetOffline, folderId, gid]);
  const joyspaceOnlineChangeEvent = useCallback((data) => {
    const { state } = data;
    // console.log('joyspaceOnlineChangeEvent', data);
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    if (
      state === ConnectState.CLOSED ||
      state === ConnectState.ERROR ||
      state === ConnectState.OFFLINE
    ) {
      if (!netServer.isStartCheck()) {
        netServer.resetStartState();
        netServer.startCheck();
      }
      if (state === ConnectState.OFFLINE) {
        setCurrentNetOffline(true);
      }
    } else if (state === ConnectState.CONNECTED) {
      setCurrentNetOffline(false);
      netServer.stopCheck();
    }
  }, []);
  useEffect(() => {
    Bus.on("chat:state", joyspaceOnlineChangeEvent);
    // focusSDK.on('wsOnlineChange', wsOnlineChangeEvent);
    return () => {
      Bus.off("chat:state", joyspaceOnlineChangeEvent);
    };
  }, [joyspaceOnlineChangeEvent]);

  return (
    <CreateMenu
      canCreateFolder={canCreateFolder}
      canCreatePage={canCreatePage}
      disabledCreateFolder={disabledCreateFolder}
      folderId={folderId}
      lowCode={isFocusEnv() ? openLowCode : undefined}
      gid={gid}
      from={PageRouteName.GROUP}
    />
  );
}
